import { useCallback, useState } from 'react'

import { resetCrudSelection } from '@/atoms'
import { deleteSimulations } from '@/features/domain/simulation'
import { useIsUnmounted, useNotification } from '@/hooks'
import { useAppDispatch } from '@/store'
import { unproxify } from '@/utils'

import { useController } from './useController'

export function useDeleteSimulations() {
  const [submitting, setSubmitting] = useState(false)

  const {
    data: { simulationIds },
    close,
  } = useController()
  const dispatch = useAppDispatch()
  const toast = useNotification()
  const isUnmounted = useIsUnmounted()

  const submit = useCallback(async () => {
    try {
      setSubmitting(true)
      const unproxifiedIds = unproxify(simulationIds)

      const result = await dispatch(deleteSimulations({ simulationIds: unproxifiedIds }))

      if (isUnmounted()) return

      if (!deleteSimulations.fulfilled.match(result)) {
        throw new Error(result.payload?.message ?? 'Internal error')
      }

      resetCrudSelection('simulations')
    } catch (e) {
      toast.error(e.message)
    } finally {
      close?.()
      setSubmitting(false)
    }
  }, [dispatch, toast, simulationIds, close, isUnmounted])

  return [submitting, submit] as const
}
